"use client";
import styled from "@emotion/styled";
import React from "react";
import { CommonCard, Layout } from "./molecules";

const OurMission = ({ data }) => {
  const BottomShape = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="252"
        height="19"
        viewBox="0 0 252 19"
        fill="none"
        className="absolute bottom-[-9px] top-auto"
      >
        <path
          d="M28.1739 18.582C27.462 18.5778 26.8587 17.7358 26.81 16.6211C26.7547 15.4533 27.3276 14.4272 28.0885 14.3362C70.8788 9.19752 114.138 6.57698 157.438 6.50389C137.548 5.72831 117.747 5.35655 98.2008 4.97569C66.3797 4.37369 33.4736 3.74406 1.5795 8.49075C0.811567 8.60296 0.146064 7.74995 0.0769306 6.58207C0.00779714 5.4142 0.566942 4.37739 1.32797 4.26514C33.3743 -0.512493 66.3565 0.1176 98.2535 0.73066C148.197 1.68388 199.84 2.66837 250.353 10.2371C251.098 10.3476 251.652 11.3592 251.59 12.505C251.528 13.6509 250.873 14.5173 250.134 14.4599C176.214 8.37668 101.573 9.76102 28.2916 18.5615C28.2501 18.5613 28.2155 18.561 28.1741 18.5608L28.1739 18.582Z"
          fill="#0096AC"
        />
      </svg>
    );
  };
  return (
    <Layout>
      <CommonCard>
        <Academy1 className="">
          <p>{data?.description}</p>
          <h3 className="text-3xl lg:text-[42px] font-extrabold relative leading-normal">
            {data?.title}
            <BottomShape />
          </h3>
        </Academy1>
      </CommonCard>
    </Layout>
  );
};

export default OurMission;

const Academy1 = styled.div`
  background: #000;
  color: #fff;
  padding: 40px;
  height: 468px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 16px;
`;
